<div class="app-root">
  <!-- Animated dark background (user-side only) -->
  @if (!isAdminRoute) {
  <div class="app-bg" aria-hidden="true">
    <div class="app-bg__blob app-bg__blob--orange"></div>
    <div class="app-bg__blob app-bg__blob--pink"></div>
    <div class="app-bg__blob app-bg__blob--amber"></div>
  </div>
  }

  @if (isAdminRoute) {
  <app-admin-navbar></app-admin-navbar>
  } @else {
  <app-navbar [isStatic]="true"></app-navbar>
  }

  <main>
    @if (isRouteLoading && !isAdminRoute) {
      <app-loader />
    }
    <router-outlet />
  </main>

  @if (!isAdminRoute) {
    <app-cart-drawer></app-cart-drawer>
  }

  <!-- Mobile bottom nav -->
  @if (!isAdminRoute) {
  <nav class="mob-nav" aria-label="Mobile navigation">
    <a routerLink="/" class="mob-nav__item" [class.mob-nav__item--active]="isNavActive('/')" (click)="selectNav('/')">
      <i class="fa-solid fa-house mob-nav__icon"></i>
      <span class="mob-nav__label">Home</span>
    </a>
    <a routerLink="/stores" class="mob-nav__item" [class.mob-nav__item--active]="isNavActive('/stores')" (click)="selectNav('/stores')">
      <i class="fa-solid fa-store mob-nav__icon"></i>
      <span class="mob-nav__label">Stores</span>
    </a>
    <a routerLink="/explore" class="mob-nav__item" [class.mob-nav__item--active]="isNavActive('/explore')" (click)="selectNav('/explore')">
      <i class="fa-solid fa-compass mob-nav__icon"></i>
      <span class="mob-nav__label">Explore</span>
    </a>
    <a routerLink="/products" class="mob-nav__item" [class.mob-nav__item--active]="isNavActive('/products')" (click)="selectNav('/products')">
      <i class="fa-solid fa-box mob-nav__icon"></i>
      <span class="mob-nav__label">Products</span>
    </a>
    <a routerLink="/login" class="mob-nav__item" [class.mob-nav__item--active]="isNavActive('/login')" (click)="selectNav('/login')">
      <i class="fa-solid fa-user mob-nav__icon"></i>
      <span class="mob-nav__label">Profile</span>
    </a>
  </nav>
  }
</div>
